(function() {
  const megas = document.querySelectorAll('.arcta-mega');
  if (!megas.length) return;

  const panelMap = {};
  megas.forEach(m => {
    const handle = m.dataset.mega;
    if (handle) panelMap[handle] = m;
  });

  const navLinks = document.querySelectorAll('.site-nav a, .header__menu a, .header__inline-menu a, nav a');

  let activePanel = null;
  let closeTimer = null;

  function openPanel(panel) {
    clearTimeout(closeTimer);
    if (activePanel && activePanel !== panel) activePanel.hidden = true;
    panel.hidden = false;
    activePanel = panel;
  }

  function schedClose() {
    closeTimer = setTimeout(() => {
      if (activePanel) { activePanel.hidden = true; activePanel = null; }
    }, 150);
  }

  navLinks.forEach(link => {
    const href = link.getAttribute('href') || '';
    const match = href.match(/\/collections\/([^\/\?#]+)/);
    if (!match) return;
    const handle = match[1];
    const panel = panelMap[handle];
    if (!panel) return;

    const parentLi = link.closest('li') || link;
    parentLi.addEventListener('mouseenter', () => openPanel(panel));
    parentLi.addEventListener('mouseleave', schedClose);
    link.addEventListener('focus', () => openPanel(panel));
  });

  megas.forEach(panel => {
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', schedClose);
  });
})();